// extracted by mini-css-extract-plugin
export default {"title":"Home_title__TijsO","subTitle":"Home_subTitle__Jke5t"};